import { render } from "./SectionTitle.vue?vue&type=template&id=17ab6d16"
const script = {}

import exportComponent from "/Users/saleem/Sites/WIMS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__